import React from 'react';
import { FaGamepad, FaGithub, FaExternalLinkAlt } from 'react-icons/fa';
import { gamesData } from '../data/gamesData';
import './Games.css';

const Games = () => {
  return (
    <section id="games" className="games">
      <div className="container">
        <h2 className="section-title">Games</h2>
        <p className="section-subtitle">
          Personal game development projects
        </p>

        <div className="games-grid grid grid-2">
          {gamesData.map((game, index) => (
            <div key={index} className="game-card card">
              {game.image && (
                <div className="game-image-wrapper">
                  <img src={game.image} alt={game.title} className="game-image" />
                </div>
              )}
              <div className="game-header">
                <div className="game-icon">
                  <FaGamepad />
                </div>
                <div className="game-category-badge">
                  {game.category}
                </div>
              </div>

              <h3 className="game-title">{game.title}</h3>
              <p className="game-description">{game.description}</p>

              <div className="game-tech">
                {game.technologies.map((tech, i) => (
                  <span key={i} className="tech-tag">{tech}</span>
                ))}
              </div>

              <div className="game-links">
                {game.github && (
                  <a 
                    href={game.github} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="game-link"
                    aria-label="View on GitHub"
                  >
                    <FaGithub /> Code
                  </a>
                )}
                {game.demo && (
                  <a 
                    href={game.demo} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="game-link"
                    aria-label="Play game"
                  >
                    <FaExternalLinkAlt /> Play
                  </a>
                )}
                {game.article && (
                  <a 
                    href={game.article} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="game-link"
                    aria-label="Read about game"
                  >
                    <FaExternalLinkAlt /> Article
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Games;
